import React, { useState, useEffect, useRef } from 'react'
import { withAuth } from '../AuthContext'
import { withRouter } from 'react-router-dom'
import { SUCCESS } from '../../utils/constants'
import { gaEvents } from '../../analytics/events'
import { shouldTranslateTo } from '../../utils/utils'
import verifyAccountStatus from '../Hooks/VerifyAccountStatus'
import TestimonialsPanel from '../TestimonialsPanel'
import Notification from '../Utils/Notification'
import styled from 'styled-components'
import {
  Title,
  Subtitle,
  CustomSubtitle,
  ActionButtons,
  LoadingButton,
} from '../Utils/CustomClasses'

const queryParams = new URLSearchParams(window.location.search)

const OnboardingTitle = styled(Title)`
  font-family: 'Open Sans', sans-serif;
`

const OnboardingSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
`

const OnboardingCustomSubtitle = styled(CustomSubtitle)`
  font-family: 'Open Sans', sans-serif;
`

const ContainerBox = styled.div`
  padding: 0 10vw 80px;
  background-color: transparent;

  @media (max-width: 799px) {
    padding: 25px 25px 25px 25px;
  }
`

const DashLineBox = styled.div`
  margin-top: 10px;
  padding: 30px 15px 40px;
  border-radius: 4px;
  border: 2px dashed #fff;

  form {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
    gap: 10px;
  }
`

const PhotoInput = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  input {
    width: 220px;
  }

  flex-direction: row;

  @media screen and (max-width: 1200px) {
    flex-direction: column;
  }
`

const FileButton = styled(ActionButtons)`
  background-color: #fff;
  border: 1px solid #000;
  color: #000;
  margin: 10px auto 0;
  padding: 10px 60px;
`

const ChooseButton = styled(FileButton)`
  background-color: #e75d66;
  border: 0;
  color: #fff;
`

const ImageLoadingButton = styled(ActionButtons)`
  margin: 10px auto;
  padding: 10px 10vw;
`

const ImageIsLoadingButton = styled(LoadingButton)`
  margin: 10px auto;
  padding: 10px 10vw;
`

const ChangePhoto = styled(PhotoInput)`
  display: block;
`

const RowBox = styled.div`
  text-align: center;
`

const ButtonBox = styled.div`
  display: block;
  width: 100%;
`

const ProceedButton = styled(ActionButtons)`
  background-color: #0bac5d;
  margin: 26px auto 0;
`

const TestimonialsWrapper = styled.div`
  margin: 80px 0 0;
`

const PhotoOnboarding = ({ data, onUpdate, onComplete }) => {
  const [file, setFile] = useState(null)
  const [filePreview, setFilePreview] = useState(null)
  const [fileName, setFileName] = useState('')
  const [choosePhotoDisplay, setChoosePhotoDisplay] = useState('flex')
  const [chosenPhotoDisplay, setChosenPhotoDisplay] = useState('none')
  const [uploadButtonDisplay, setUploadButtonDisplay] = useState('none')
  const [changePhotoDisplay, setChangePhotoDisplay] = useState('none')
  const [currentProfilePic, setCurrentProfilePic] = useState('')
  const [pageText, setPageText] = useState([])
  const [reload, setReload] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const hiddenFileInput = useRef(null)

  useEffect(() => {
    gaEvents.eventGeneric(
      'page_load',
      'upload-photo-page-loaded',
      data.auth.user.id + ' - upload photo - page loaded'
    )

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    setCurrentProfilePic(data.auth.user.profilePhotoL)

    getPageText('profile-photo', language)
  }, [])

  useEffect(() => {
    !queryParams.get('s') && data.auth.user.profilePhotoL && onUpdate('pr-comp')
  }, [data.auth.user.profilePhotoL])

  const handleClick = (e) => {
    e.preventDefault()
    hiddenFileInput.current.click()
  }

  const handleChange = (e) => {
    setFilePreview(URL.createObjectURL(e.target.files[0]))
    setFile(e.target.files[0])
    setFileName(e.target.files[0].name)
    setChoosePhotoDisplay('none')
    setChosenPhotoDisplay('block')
    setUploadButtonDisplay('flex')
    setChangePhotoDisplay('block')
  }

  const handleSubmit = (e) => {
    gaEvents.eventGeneric('form_submit', 'submitted', 'Upload profile photo')

    e.preventDefault()
    setIsLoading(true)

    const formData = new FormData()
    formData.append('file', file)
    const headers = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }

    axios
      .post('/api/upload-photo', formData, headers)
      .then((response) => {
        Notification({
          type: SUCCESS,
          message: `${pageText[6]}`,
        })

        const photoDetails = {
          profilePhotoO: `gfx/users/original/${response.data.path}`,
          profilePhotoL: `gfx/users/large/${response.data.path}`,
          profilePhotoS: `gfx/users/small/${response.data.path}`,
          profilePhotoStatus: 'completed',
        }

        setCurrentProfilePic(`gfx/users/large/${response.data.path}`)
        setChoosePhotoDisplay('flex')
        setChosenPhotoDisplay('none')
        setUploadButtonDisplay('none')
        setChangePhotoDisplay('none')
        setReload(false)

        data.auth.updateUser(photoDetails)

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        data.auth.subscriptionType !== null &&
          data.auth.subscriptionType !== '' &&
          verifyAccountStatus(data, 'photo')

        setTimeout(function () {
          onUpdate('pr-comp')
        }, 1000)

        setIsLoading(false)
      })
      .catch((e) => {
        Notification({
          data: e,
        })
        setIsLoading(false)
      })
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border onboarding-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[15]}</span>
        </div>
      </div>
    )
  }
  return (
    <ContainerBox>
      <OnboardingTitle
        center
        color="#ff9900"
        size="34px"
        sizemd="34px"
        sizesm="34px"
        margin="10px 0 0"
        dangerouslySetInnerHTML={{
          __html: !queryParams.get('s') ? pageText[16] : pageText[17],
        }}
      ></OnboardingTitle>

      {data.auth.user.profilePhotoL && reload === false ? (
        <RowBox>
          <OnboardingSubtitle
            color="#fff"
            center
            size="24px"
            sizesm="24px"
            weight="700"
            margin="10px 0 30px"
            dangerouslySetInnerHTML={{
              __html: !queryParams.get('s') ? pageText[18] : pageText[19],
            }}
          ></OnboardingSubtitle>
          <OnboardingSubtitle
            color="#fff"
            size="18px"
            center
            weight="400"
            margin="10px 0 5px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[8]}`,
            }}
          />
          <img
            src={
              'https://fbc-int.s3.eu-west-1.amazonaws.com/' + currentProfilePic
            }
            style={{
              width: '100%',
              maxWidth: '220px',
              margin: '0 0 20px 0',
            }}
          />
        </RowBox>
      ) : (
        <OnboardingSubtitle
          color="#fff"
          center
          size="24px"
          sizesm="24px"
          weight="700"
          margin="10px 0 30px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[7]}`,
          }}
        ></OnboardingSubtitle>
      )}

      {!data.auth.user.profilePhotoL ||
      (data.auth.user.profilePhotoL && reload === true) ? (
        <DashLineBox>
          <form
            method="POST"
            action="/"
            name="myForm"
            aria-label="Verify photo"
            onSubmit={(event) => {
              event.preventDefault()
              handleSubmit(event)
              return false
            }}
          >
            <input
              type="hidden"
              name="csrf-token"
              value={window.Laravel.csrfToken}
            />

            <PhotoInput>
              <ChooseButton
                style={{ display: choosePhotoDisplay }}
                onClick={handleClick}
              >
                {pageText[14]}
              </ChooseButton>
              <input
                type="file"
                onChange={(e) => handleChange(e)}
                ref={hiddenFileInput}
                style={{ display: 'none' }}
              />
              {reload === true && chosenPhotoDisplay !== 'block' && (
                <FileButton onClick={() => setReload(false)}>
                  {pageText[20]}
                </FileButton>
              )}
            </PhotoInput>

            <OnboardingSubtitle
              color="#fff"
              center
              size="18px"
              weight="400"
              margin="0 0 15px"
              style={{ display: chosenPhotoDisplay }}
              dangerouslySetInnerHTML={{
                __html: `<strong>${pageText[9]}</strong>`,
              }}
            />

            {chosenPhotoDisplay == 'block' && (
              <img
                src={filePreview}
                style={{ width: '100%', maxWidth: '250px' }}
              />
            )}

            <ButtonBox>
              {isLoading ? (
                <ImageIsLoadingButton padding="10px 9vw">
                  {pageText[10]}
                </ImageIsLoadingButton>
              ) : (
                <ImageLoadingButton
                  type="submit"
                  padding="10px 10vw"
                  style={{ display: uploadButtonDisplay }}
                >
                  {pageText[11]}
                </ImageLoadingButton>
              )}
            </ButtonBox>

            <ChangePhoto style={{ display: changePhotoDisplay }}>
              <Subtitle
                color="#fff"
                center
                size="18px"
                weight="400"
                margin="10px 0 19px"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[13]}`,
                }}
              />

              <FileButton onClick={handleClick}>{pageText[12]}</FileButton>
            </ChangePhoto>

            <OnboardingSubtitle
              color="#fff"
              center
              size="18px"
              weight="400"
              margin="20px 0 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[3]}`,
              }}
            />
          </form>
        </DashLineBox>
      ) : (
        <ChangePhoto>
          {!queryParams.get('s') && (
            <>
              <ProceedButton
                type="submit"
                padding="10px 60px"
                margin="46px 10vw 26px"
                fontsize="16px"
                onClick={() => {
                  onComplete('mp0')
                }}
              >
                {pageText[21]}
              </ProceedButton>
              <OnboardingSubtitle
                color="#fff"
                center
                size="18px"
                weight="400"
                margin="10px 0 19px"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[13]}`,
                }}
              />
            </>
          )}

          <FileButton onClick={() => setReload(true)}>
            {pageText[12]}
          </FileButton>
        </ChangePhoto>
      )}

      {!data.auth.user.profilePhotoL && (
        <OnboardingCustomSubtitle
          color="#fff"
          center
          size="18px"
          margin="28px 10% 0 10%"
          marginsm="48px 5% 0 5%"
          weight="200"
          dangerouslySetInnerHTML={{
            __html: `${pageText[5]}`,
          }}
        />
      )}

      {/* Testimonials */}
      <TestimonialsWrapper>
        <TestimonialsPanel
          color={'transparent'}
          textcolor={'#ffffff'}
          showintro={false}
          numbertoshow={1}
          step={2}
        />
      </TestimonialsWrapper>
    </ContainerBox>
  )
}

export default withRouter(withAuth(PhotoOnboarding))
